/**
 * Тосты с отменой.
 *
 * Няня делает всё в один тап, значит промах тоже случается в один тап.
 * Undo в течение 5 секунд дешевле любого диалога подтверждения и не мешает
 * скорости — поэтому подтверждений на создание события нет, а Undo есть.
 */

import { create } from 'zustand'

export type ToastTone = 'default' | 'success' | 'error'

export interface Toast {
  id: number
  text: string
  tone: ToastTone
  undoLabel?: string
  onUndo?: () => void
  durationMs: number
}

interface ToastStore {
  toasts: Toast[]
  push: (toast: Omit<Toast, 'id' | 'tone' | 'durationMs'> & Partial<Toast>) => number
  dismiss: (id: number) => void
}

let nextId = 1

export const useToastStore = create<ToastStore>((set) => ({
  toasts: [],
  push: (toast) => {
    const id = nextId++
    const item: Toast = {
      id,
      text: toast.text,
      tone: toast.tone ?? 'default',
      undoLabel: toast.undoLabel,
      onUndo: toast.onUndo,
      durationMs: toast.durationMs ?? (toast.onUndo ? 5000 : 2600),
    }
    set((state) => ({ toasts: [...state.toasts, item] }))
    return id
  },
  dismiss: (id) => set((state) => ({ toasts: state.toasts.filter((t) => t.id !== id) })),
}))

export const toast = {
  show: (text: string, options?: Partial<Toast>) =>
    useToastStore.getState().push({ text, ...options }),
  success: (text: string, options?: Partial<Toast>) =>
    useToastStore.getState().push({ text, tone: 'success', ...options }),
  error: (text: string, options?: Partial<Toast>) =>
    useToastStore.getState().push({ text, tone: 'error', ...options }),
  /** Действие выполнено оптимистично; 5 секунд можно передумать. */
  undoable: (text: string, onUndo: () => void) =>
    useToastStore.getState().push({ text, onUndo, undoLabel: 'Отменить' }),
}
